module.exports = __webpack_public_path__ + "static/047-389befa1c4eebdf87b58bf6063311638.jpg";